// original: https://git.hubteam.com/HubSpot/conversations-internal-schema/blob/1729733ab4b5cfdd5950af37c67157f5deb9589b/static/js/team/records/Team.js
import { List as ImmutableList } from 'immutable';
import { TeamBase } from './TeamBase';
/**
 * @description An Immutable.Record for a team for teams returned from the `GET app-users/v1/teams` API
 */
export const AppUsersTeam = TeamBase({
  secondaryUserIds: ImmutableList(),
  userIds: ImmutableList()
}, 'AppUsersTeam');